export default __webpack_public_path__ + "static/media/broken_link.04cfe6b1.svg";